import Vue from 'vue'
import Vuex from 'vuex'
// import modules
import { auth } from './modules/auth'

Vue.use(Vuex)
// Vuex is the store app, that's where we gonna reate some modules to be access between the components

export const store = new Vuex.Store({
  // Making sure that we're doing
  // everything correctly by enabling
  // strict mode in the dev environment.
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    auth
  }
})
